// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Menu  (route /menu)
// Sticky "N items · ₹total — View cart" bar, shown only while the cart has something in it. The total
// is the item subtotal from the cart (delivery and any coupon are worked out at checkout). Leaves room on
// the right so it doesn't sit under the floating chat/WhatsApp buttons on a phone.
// ─────────────────────────────────────────────────────────────────────────────
import { Link } from "react-router-dom";
import { ArrowRight, ShoppingBag } from "lucide-react";
import useCart from "../../hooks/useCart";
import { formatInr } from "../../utils/priceFormat";

export default function CartBar() {
  const { lines, totalKg, subtotal } = useCart();
  if (lines.length === 0) return null;
  const catches = new Set(lines.map((line) => line.item.id)).size;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-4 z-40 px-4 pr-20 sm:pr-4">
      <Link
        to="/checkout"
        className="pointer-events-auto mx-auto flex max-w-xl items-center justify-between gap-3 rounded-full bg-ocean-800 px-5 py-3 text-white shadow-lg shadow-ocean-950/30 transition-colors hover:bg-ocean-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-400"
      >
        <span className="flex items-center gap-2 text-sm font-bold">
          <ShoppingBag className="h-5 w-5" aria-hidden="true" />
          {catches} {catches === 1 ? "item" : "items"} · {totalKg} kg
        </span>
        <span className="flex items-center gap-2 text-sm font-bold">
          {formatInr(subtotal)}
          <span className="inline-flex items-center gap-1 rounded-full bg-white/15 px-3 py-1">
            View cart <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </span>
        </span>
      </Link>
    </div>
  );
}
